import pl1 from "./pl1.svg";
import pl2 from "./pl2.svg";
import pl3 from "./pl3.svg";
import pl4 from "./pl4.svg";
import pl5 from "./pl5.svg";
import pr1 from "./pr1.svg";
import pr2 from "./pr2.svg";
import pr3 from "./pr3.svg";
import pr4 from "./pr4.svg";

export const pieLabels = { pl1, pl2, pl3, pl4, pl5, pr1, pr2, pr3, pr4 };
